import { prod } from "application/constants/app-constants";

export default function getStlocId() {
  let stlocId = "3862";
  if (prod) {
    const urlParams = new URLSearchParams(window.location.search);
    stlocId = urlParams.get("stlocId");
  }
  return stlocId;
}
